'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('event-reservation-show', {
      url: '/event-reservation/:id',
      template: '<event-reservation-show></event-reservation-show>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/reservation/event/show/event-reservation-show.routes.js